module.exports = __webpack_public_path__ + "static/media/Vivian_T.b04daf44.jpg";